$(document).ready(function(){
  
  var form = $('.form');
  form.on('submit', function(e) {
  	$('html, body').animate({scrollTop: $(this).offset().top - 30}, 'slow');
  });

  form.on('freeform-ajax-success', function(event) {
    setTimeout(function(){
      hideOptionalFields();
    }, 500);
  });


  // -- contact form V2 --
  if ($('.form--contactV2').length) {

    var hideOptionalFields = function(){
      $('[name="currentSiteHandle"], [name="companyName"], [name="productDescription"], [name="contentWeight"], [name="bestBeforeDate"], [name="batchNumber"], [name="pointOfPurchase"], [name="attachment[]"]').val('').parents('.wrapper').hide();
      $('[name="currentSiteHandle"] option:selected').prop('selected', false);
      $('select').niceSelect('update');
    };

    // -- hide optional inputs --
    hideOptionalFields();

    // -- show optional inputs --
    $('.form--contactV2 select[name="dynamicRecipientsV2"]').on('change', function(){
      $val = $(this).val();
      hideOptionalFields();

      if ($val == 0) {
        $('[name="currentSiteHandle"] option.current').prop('selected', true);
        $('[name="currentSiteHandle"]').niceSelect('update');

      } else if ($val == 1) {
        $('[name="productDescription"], [name="contentWeight"], [name="bestBeforeDate"], [name="batchNumber"], [name="pointOfPurchase"], [name="attachment[]"]').parents('.wrapper').show();

      } else if ($val == 2 || $val == 3) {
       $('[name="companyName"]').parents('.wrapper').show();
        
      } else {
        hideOptionalFields();
      }
    });
  }

  // -- contact form Naturata --
  if ($('.form--contactNaturata').length) {

    var hideOptionalFields = function(){
      $('[name="currentSiteHandle"], [name="loyaltyCardNumberGiftCardNumber"], [name="customerNumber"], [name="productDescription"], [name="contentWeight"], [name="bestBeforeDate"], [name="batchNumber"], [name="placeOfPurchase"]').val('').parents('.wrapper').hide();
      $('[name="currentSiteHandle"] option:selected').prop('selected', false);
      $('select').niceSelect('update');
    };

    // -- hide optional inputs --
    hideOptionalFields();

    // -- show optional inputs --
    $('.form--contactNaturata select[name="dynamicRecipientsNaturata"]').on('change', function(){
      $val = $(this).val();
      hideOptionalFields();
      if ($val == 0) {
        $('[name="currentSiteHandle"] option.current').prop('selected', true);
        $('[name="currentSiteHandle"]').niceSelect('update');

      } else if ($val == 1) {
        $('[name="productDescription"], [name="contentWeight"], [name="bestBeforeDate"], [name="batchNumber"], [name="placeOfPurchase"]').parents('.wrapper').show();

      } else if ($val == 2) {
       $('[name="loyaltyCardNumberGiftCardNumber"], [name="customerNumber"]').parents('.wrapper').show();
        
      } else {
        hideOptionalFields();
      }
    });
  }


});
